<template >
  <div class="mainbody">
    <div class="tableHead">
      <div class="box">
        <p class="title1">等待审核</p>
        <p class="title2">{{ waitExamineCount }}个校友</p>
      </div>
      <div class="aLine"></div>
      <div class="box">
        <p class="title1">本周审核平均处理时间</p>
        <p class="title2">{{ averageExamineTime }}</p>
      </div>
      <div class="aLine"></div>
      <div class="box">
        <p class="title1">本周完成审核数</p>
        <p class="title2">{{ examineCount }}个</p>
      </div>
    </div>
    <div class="tableInfo">
      <el-table
        :data="data_list"
        @row-click="toDetails"
        @filter-change="filterChange"
      >
        <el-table-column prop="id" label="ID" min-width="1"></el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="1"
        ></el-table-column>
        <el-table-column
          prop="experience"
          label="在校经历"
          min-width="1"
        ></el-table-column>
        <el-table-column
          prop="year"
          label="在校时间"
          min-width="2"
        ></el-table-column>
        <el-table-column
          prop="division"
          label="学部"
          min-width="3"
        ></el-table-column>
        <el-table-column
          prop="programme"
          label="专业"
          min-width="3"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="提交时间"
          min-width="3"
        ></el-table-column>
        <el-table-column
          prop="result"
          label="审核状态"
          min-width="1"
          :filters="optionsExamine"
          filter-placement="bottom-end"
          column-key="filterResult"
        ></el-table-column>
        <!-- <el-table-column
          prop="operating"
          label="操作"
          min-width="2"
          align="left"
        >
          <template slot-scope="scope">
            <el-button
              class="operateText"
              size="mini"
              type="text"
              @click="newsEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              class="operateText"
              size="mini"
              type="text"
              @click="newsDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        :key="elementui_page_key"
        class="elPagination"
        background
        layout="prev, pager, next"
        :page-size="pageMaxSize"
        :page-count="pageCount"
        :current-page="currentPage"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import * as Utils from "@/utils/utils.js";
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";
import * as Constant from "@/utils/constant.js";

export default {
  components: {},
  data() {
    return {
      urlPath: URL_PATH,
      data_list: [], //数据列表
      optionsExamine: Constant.options_examine,
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1,
      waitExamineCount: 0,
      averageExamineTime: 0,
      examineCount: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList: function () {
      this.$api
        .dataAuthenticationList({
          token: localStorage.getItem("token"),
          page: this.currentPage,
          limit: this.pageMaxSize,
          screen_result: this.screen_result,
        })
        .then(({ data }) => {
          this.waitExamineCount = data.Data.waitExamineCount;
          this.averageExamineTime = StrUtils.formatSeconds(
            data.Data.averageExamineTime
          );
          this.examineCount = data.Data.examineCount;

          let current_page = Utils.listPage(data, this.currentPage);
          if (current_page) {
            this.currentPage = current_page;
            this.getList();
          }
          this.pageCount = data.Data.pageCount;
          this.data_list = data.Data.model;
          this.data_list.forEach((info) => {
            this.optionsExamine.forEach((examin) => {
              if (info.result == parseInt(examin.value)) {
                info.result = examin.text;
              }
            });
            info.createTime = Utils.dateFormat(info.create_time * 1000);
          });
        })
        .catch(({ error }) => {});
    },
    // 过滤
    filterChange(filters) {
      this.screen_result = StrUtils.getStr4List1(filters.filterResult);
      if (this.screen_result == "") this.screen_result = undefined;
      this.getList();
    },
    currentChange(val) {
      this.elementui_page_key++;
      this.currentPage = val;
      this.getList();
    },
    // 查看详情
    toDetails(row, column, event) {
      this.$router.push({
        path: "/wxapp/authentication_data_details",
        query: {
          id: row.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mainbody {
  // overflow: hidden;
  // background-color: #ffffff;
  border-radius: 5px;
  // padding-bottom: 58px;
}
.mainbody .tableHead {
  background-color: #ffffff;
  box-sizing: border-box;
  margin-bottom: 16px;
  overflow: hidden; /*溢出的部分隐藏*/
}
.mainbody .tableHead .box {
  padding: 24px;
  width: 29%;
  height: 50px;
  float: left;
  text-align: center;
}
.mainbody .tableHead .title1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}
.mainbody .tableHead .title2 {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  color: #000000;
}
.mainbody .tableHead .aLine {
  float: left;
  background-color: #e9e9e9;
  width: 1px;
  height: 56px;
  margin-top: 25px;
}
.mainbody .tableInfo {
  background-color: #ffffff;
  box-sizing: border-box;
  // margin-top: 24px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 32px;
  overflow: hidden; /*溢出的部分隐藏*/
}
</style>


// WEBPACK FOOTER //
// src/components/authentication/dataAuthenticationList.vue